import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout' // 页面布局

/* Router Modules */
//import componentsRouter from './modules/components'
//import chartsRouter from './modules/charts'
//import tableRouter from './modules/table'
//import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
    path: '/bind',
    component: () => import('@/views/bind/bind'),
    hidden: true,
    meta: {
      title: '绑定账号',
    }
  },
  {
    path: '/scan',
    component: () => import('@/views/bind/scan'),
    hidden: true,
    meta: {
      title: '扫码登录',
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      name: 'Dashboard',
      meta: {
        title: '首页',
        icon: 'dashboard',
        affix: true
      }
    }]
  },

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [{
    path: '/agent',
    component: Layout,
    redirect: '/agent/list',
    name: 'Agent',
    meta: {
      title: '代理商管理',
      icon: 'el-icon-s-help'
    },
    children: [{
        path: 'list',
        component: () => import('@/views/agent/list'),
        name: 'AgentList',
        meta: {
          title: '代理商列表',
          icon: 'list'
        }
      },
      {
        path: 'edit',
        component: () => import('@/views/agent/form'),
        name: 'AgentEdit',
        meta: {
          title: '添加代理商',
          icon: 'edit'
        }
      },
    ]
  },
  {
    path: '/card',
    component: Layout,
    redirect: '/card/list',
    name: 'Card',
    meta: {
      title: '卡管理',
      icon: 'el-icon-s-help'
    },
    children: [{
      path: 'list',
      component: () => import('@/views/card/list'),
      name: 'CardList',
      meta: {
        title: '卡列表',
        icon: 'list'
      }
    }, {
      path: 'assign',
      component: () => import('@/views/card/assign'),
      name: 'CardAssign',
      meta: {
        title: '卡调拨',
        icon: 'list'
      }
    }]
  },

  {
    path: '/wifi',
    component: Layout,
    redirect: '/wifi/index',
    name: 'Wifi',
    meta: {
      title: '设备租赁',
      icon: 'el-icon-magic-stick'
    },
    children: [{
      path: 'index',
      component: () => import('@/views/wifiorder/index'),
      name: 'WifiOrder',
      meta: {
        title: '租赁订单',
        icon: 'list'
      },
    }]
  },

  {
    path: '/cardstatistics',
    component: Layout,
    redirect: '/cardstatistics/loss',
    name: 'CardStatistics',
    meta: {
      title: '卡片统计',
      icon: 'el-icon-s-help'
    },
    children: [{
      path: 'loss',
      component: () => import('@/views/cardstatistics/loss'),
      name: 'LossList',
      meta: {
        title: '流失列表',
        icon: 'list'
      }
    }]
  },

  {
    path: '/agentprice',
    component: Layout,
    redirect: '/agentprice/groups',
    meta: {
      title: '我的套餐',
      icon: 'edit'
    },
    children: [{
        path: 'groups',
        component: () => import('@/views/agentprice/salegroups'),
        name: 'groups',
        meta: {
          title: '我的套餐',
          icon: 'edit'
        }
      }, {
        path: 'salegroups',
        component: () => import('@/views/agentprice/salegroups'),
        name: 'salegroups',
        meta: {
          title: '代理套餐组',
          icon: 'edit'
        },
        hidden: true
      },
      {
        path: 'settlement',
        component: () => import('@/views/agentprice/settlementprice'),
        name: 'SettlementPrice',
        meta: {
          title: '结算价设置',
          icon: 'edit'
        },
        hidden: true
      }
    ]
  },


  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    name: 'Order',
    meta: {
      title: '订单管理',
      icon: 'el-icon-s-help'
    },
    children: [{
      path: 'list',
      component: () => import('@/views/order/index'),
      name: 'OrderList',
      meta: {
        title: '订单列表',
        icon: 'list'
      }
    }, {
      path: 'charge',
      component: () => import('@/views/chargeorder/index'),
      name: 'ChargeList',
      meta: {
        title: '预存订单',
        icon: 'list'
      }
    }]
  },

  {
    path: '/commission',
    component: Layout,
    redirect: '/commission/list',
    name: 'Commission',
    meta: {
      title: '佣金管理',
      icon: 'el-icon-s-help'
    },
    children: [{
      path: 'list',
      component: () => import('@/views/commission/list'),
      name: 'CommissionList',
      meta: {
        title: '佣金列表',
        icon: 'list'
      }
    }]
  },

  {
    path: '/account',
    component: Layout,
    redirect: '/account/items',
    name: 'Account',
    meta: {
      title: '账户管理',
      icon: 'el-icon-s-help'
    },
    children: [{
      path: 'items',
      component: () => import('@/views/account/items'),
      name: 'AccountItems',
      meta: {
        title: '账户流水',
        icon: 'list'
      }
    }]
  },

  {
    path: '/withdrawal',
    component: Layout,
    redirect: '/withdrawal/list',
    name: 'Withdrawal',
    meta: {
      title: '提现管理',
      icon: 'el-icon-s-help'
    },
    children: [{
      path: 'list',
      component: () => import('@/views/withdrawal/list'),
      name: 'WithdrawalList',
      meta: {
        title: '提现',
        icon: 'list'
      }
    }]
  },


]

const createRouter = () => new Router({
  mode: 'history', // require service support
  //history: createWebHistory(),
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js